/* eslint-disable import/prefer-default-export */
import LockIcon from '@material-ui/icons/Lock';
import PublicIcon from '@material-ui/icons/Public';
import LinkIcon from '@material-ui/icons/Link';

export const PRIVACY_OPTIONS = [
  { Icon: PublicIcon, value: 'public', label: 'Public', secondary: 'Anyone on the Internet' },
  {
    Icon: LinkIcon,
    value: 'unlisted',
    label: 'Unlisted',
    secondary: 'Only people you share the link with',
  },
  { Icon: LockIcon, value: 'private', label: 'Private', secondary: 'Only you' },
];
